import '@angular/localize/init';
export * from './lib/feature-tax-report-list.module';

export * from './lib/tax-report-list/feature-tax-report-list.component';
